export class WorkItemsFromQueueInput{
    public crmUserId:number;
    public endDate:string;
    public queueIds:Array<any>;
    public sessionToken:string;
    public startDate:string;
    public workItemStatusList:Array<string>;
}